module.exports = __webpack_public_path__ + "static/media/girl1.47d7fe45.jpg";